'use client';

import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '@/redux/store';
import { toggleSidebar } from '@/redux/store/features';
import { CloseIcon, MenuHamburgerIcon } from '@/assets/icons';
import { Button } from '@/components/ui';

const BurgerMenu = () => {
  const dispatch = useDispatch();
  const sidebarOpen = useSelector((state: RootState) => state.features?.sidebarOpen ?? false);

  return (
    <Button
      type="button"
      onClick={() => dispatch(toggleSidebar())}
      className="navbar-burger text-prose"
      aria-label="Toggle navigation menu"
      aria-expanded={sidebarOpen}
    >
      {sidebarOpen ? (
        <CloseIcon className="h-6 w-6" />
      ) : (
        <MenuHamburgerIcon className="h-6 w-6" />
      )}
    </Button>
  );
};

export default BurgerMenu;
